import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
import { getPlainContent } from 'flarum/common/utils/string';
import ItemList from 'flarum/common/utils/ItemList';
import Badge from 'flarum/common/components/Badge';
export default class Page extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "title", Model.attribute('title'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "contentHtml", Model.attribute('contentHtml'));
    _defineProperty(this, "contentPlain", computed('contentHtml', function (contentHtml) {
      return getPlainContent(contentHtml);
    }));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "isHidden", Model.attribute('isHidden'));
    _defineProperty(this, "isRestricted", Model.attribute('isRestricted'));
    _defineProperty(this, "isHtml", Model.attribute('isHtml'));
  }
  badges() {
    const items = new ItemList();
    if (this.isHidden()) {
      items.add('hidden', Badge.component({
        type: 'hidden',
        icon: 'fas fa-trash',
        label: app.translator.trans('fof-pages.admin.badges.hidden')
      }));
    }
    if (this.isRestricted()) {
      items.add('restricted', Badge.component({
        type: 'restricted',
        icon: 'fas fa-user-shield',
        label: app.translator.trans('fof-pages.admin.badges.restricted')
      }));
    }
    return items;
  }
}
flarum.reg.add('fof-pages', 'common/models/Page', Page);